import { Component, OnInit } from '@angular/core';
import {LanguageService} from './../../services/language.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  language:any;

  constructor(private languageService:LanguageService) { }

  ngOnInit() {

    this.languageService.currenLanguage.subscribe((result:any)=>{

      console.log("header",result);

      this.language = result;

    })

  }

}
